<template>
  <div id="sidebar" class="flex-shrink-0" :class="{ 'burger-expand': mobileExpand }">
    <router-link :to="{ name: 'home' }" data-cy="sidemenu-logo">
      <div class="long-logo">
        <img src="@/assets/svg/Logo_Horizontal_Gradient_Dark_Transparent.svg" />
      </div>
      <div class="logo">
        <img src="@/assets/svg/Icon_Gradient.svg" />
      </div>
    </router-link>

    <div class="burger-menu" @click="mobileExpand = !mobileExpand">
      <div class="icon-wrapper">
        <i class="fa-light fa-bars"></i>
      </div>
    </div>

    <div class="buttons">
      <router-link
        :to="{ name: 'home' }"
        exact
        tag="div"
        class="area-button"
        data-cy="sidemenu-templates"
        ref="homebutton"
      >
        <div class="icon-wrapper">
          <i class="fa-light fa-file home-area-icon"></i>
        </div>
        <span class="router-desc">{{ $t("sidemenu.templates") }}</span>
      </router-link>

      <router-link
        :to="{ name: 'data' }"
        exact
        tag="div"
        class="area-button"
        data-cy="sidemenu-integrations"
        ref="databutton"
      >
        <div class="icon-wrapper">
          <i class="fa-light fa-database data-area-icon"></i>
        </div>
        <span class="router-desc">{{ $t("sidemenu.data") }}</span>
      </router-link>

      <router-link :to="{ name: 'settings' }" tag="div" class="area-button" data-cy="sidemenu-settings">
        <div class="icon-wrapper">
          <i class="fa-light fa-cog settings-area-icon"></i>
        </div>
        <span class="router-desc">{{ $t("sidemenu.settings") }}</span>
      </router-link>

      <div class="area-button logout-btn" @click="logOut" data-cy="sidemenu-logout">
        <div class="icon-wrapper">
          <i class="fa-light fa-sign-out"></i>
        </div>
        <span class="router-desc">{{ $t("sidemenu.signout") }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import ConfirmModal from "@/components/modals/ConfirmModal";
export default {
  name: "sidemenu",
  data() {
    return {
      expand: false,
      mobileExpand: false
    };
  },
  methods: {
    logOut() {
      this.$modal.show(
        ConfirmModal,
        {
          title: this.$t("logout.title"),
          description: this.$t("logout.desc"),
          confirmButtonText: this.$t("logout.confirm"),
          onConfirm: (result) => {
            this.$store.dispatch("logOut").then(() => {
              this.$router.push("login");
              location.reload();
            });
          }
        },
        { width: 350, height: "auto", adaptive: true }
      );
    }

    // handleDemoGuide() {
    //   const demoPopupPlacement = this.$refs.databutton.$el.getBoundingClientRect();
    //   this.$store.commit("addPositionToDemoGuide", {
    //     step: 1,
    //     x: demoPopupPlacement.right,
    //     y: demoPopupPlacement.y,
    //     placement: "right"
    //   });
    //   const demoPopupPlacementHome = this.$refs.homebutton.$el.getBoundingClientRect();
    //   this.$store.commit("addPositionToDemoGuide", {
    //     step: 3,
    //     x: demoPopupPlacementHome.right,
    //     y: demoPopupPlacementHome.y,
    //     placement: "right"
    //   });
    // }
  },
  // computed: {
  //   postDemoGuide() {
  //     return this.$store.state.postDemoGuide;
  //   }
  // },
  // watch: {
  //   postDemoGuide: {
  //     handler: function() {
  //       if (this.postDemoGuide == true) {
  //         this.handleDemoGuide();
  //       }
  //     },
  //     immediate: true
  //   }
  // },
  mounted() {},
  components: {}
};
</script>

<style lang="less">
#sidebar {
  width: 81px;
  overflow: hidden;
  white-space: nowrap;
  transition: width 0.1s;
  position: absolute;
  z-index: 2;
  box-shadow: 2px 2px 4px 0 rgba(89, 102, 107, 0.4);
  margin: 18px;
  background-color: #fff;
  border-radius: 10px;
  .logo {
    display: flex;
    align-items: flex-start;
    margin: 32px 28px;
    img {
      width: 25px;
    }
  }
  .long-logo {
    opacity: 0;
    width: 0;
    height: 0;
  }
  .burger-menu {
    display: none;
  }

  .buttons {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    padding: 0 20px;
    padding-bottom: 32px;
  }
  .area-button {
    cursor: pointer;
    padding: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--alabaster-40);
    font-size: 18px;
    border-radius: 10px;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.15);
    transition: box-shadow 0.1s ease-in-out;

    &.logout-btn {
      color: var(--flame);
      background-color: var(--flame-10);
      &:hover {
        background-color: var(--flame-20);
      }
    }
    .router-desc {
      opacity: 0;
      width: 0;
      height: 0;
      font-size: 12px;
    }

    &.router-link-active {
      background-color: var(--orange-web-20);
      svg {
        color: var(--orange-web);
        // background-color: var(--alabaster-80);
      }
      .router-desc {
        color: var(--orange-web);
      }
      &:hover {
        background-color: var(--orange-web-40);
      }
    }

    &:hover {
      background-color: var(--alabaster-80);
      box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
    }
  }

  .icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
  }
}

@media screen and (min-width: 620px) {
  #sidebar {
    &:hover {
      width: 193px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      .long-logo {
        margin: 24px 20px 25px;
        // text-align: center;
        img {
          width: 153px;
        }
      }
      .logo {
        opacity: 0;
        width: 0;
        height: 0;
        margin: 0;
      }

      .long-logo {
        opacity: 1;
        width: auto;
        height: auto;
      }

      .buttons {
        position: relative;
        display: flex;
        width: 100%;
        padding: 0 20px;
        padding-bottom: 32px;
      }
      .area-button {
        padding: 12px;
        width: auto;
        width: 100%;
        display: flex;
        justify-content: space-between;
        &.logout-btn {
          color: var(--flame);
          .router-desc {
            color: var(--flame);
          }
        }
      }
      // .icon-wrapper{
      //   padding: 12px;
      // }

      .router-desc {
        font-weight: 500;
        margin-left: 12px;
        color: var(--charcoal-75);
        font-size: 12px;
        right: 0;
        position: absolute;
        right: 36px;
        opacity: 1;
        width: auto;
        height: auto;
        transition: opacity 0.5s;
      }
    }
  }

  #app #home,
  #app #settings,
  #app #data-area {
    padding: 0 24px 0 calc(var(--sidebar-width) + 24px);
  }
}

@media screen and (max-width: 620px) {
  #sidebar .buttons {
    display: none;
  }

  #app #home,
  #app #settings,
  #app #data-area {
    padding: 0 18px 0 18px;
  }

  #sidebar {
    position: fixed;
    margin: 12px;
    display: flex;
    justify-content: space-between;
    width: calc(100% - 24px);
    .burger-menu {
      display: block;
      margin: 4px;
      position: absolute;
      right: 0;

      cursor: pointer;
      padding: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      // background-color: var(--alabaster-40);
      font-size: 18px;
      border-radius: 10px;
      // box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.15);
      transition: box-shadow 0.1s ease-in-out;
    }

    .logo {
      margin: 12px;
    }

    &.burger-expand {
      display: flex;
      flex-direction: column;
      .long-logo {
        display: block;
        margin: 4px 4px;
        opacity: 1;
        width: auto;
        height: auto;

        img {
          width: 154px;
        }
      }
      .logo {
        opacity: 0;
        width: 0;
        height: 0;
        margin: 0;
      }

      .buttons {
        position: relative;
        display: flex;
        width: 100%;
        padding: 0 20px;
        padding-bottom: 32px;
      }
      .area-button {
        padding: 12px;
        width: auto;
        width: 100%;
        display: flex;
        justify-content: space-between;

        &.logout-btn {
          color: var(--flame);
          .router-desc {
            color: var(--flame);
          }
        }
      }
      .router-desc {
        font-weight: 500;
        // display: block;
        width: max-content;
        // left: 100%;
        color: var(--charcoal-75);
        font-size: 12px;

        opacity: 1;
        width: auto;
        height: auto;

        transition: opacity 0.4s;
      }
    }
  }
}
</style>
